const LIGHTWEIGHT_CHARTS_SRC =
  "https://unpkg.com/lightweight-charts@4.2.1/dist/lightweight-charts.standalone.production.js";

let lightweightChartsPromise = null;

export const hideAttribution = (container) => {
  if (!container) return;
  const nodes = container.querySelectorAll(
    'a[href*="tradingview.com"], a[title*="TradingView"], .tv-attribution, .tv-logo'
  );
  nodes.forEach((node) => {
    node.style.display = "none";
    node.setAttribute("aria-hidden", "true");
  });
};

export const installAttributionHider = (container) => {
  if (!container || typeof MutationObserver === "undefined") return null;
  hideAttribution(container);
  const observer = new MutationObserver(() => {
    hideAttribution(container);
  });
  observer.observe(container, { childList: true, subtree: true });
  return observer;
};

export const loadLightweightCharts = () => {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("lightweight-charts requires a browser"));
  }

  if (window.LightweightCharts?.createChart) {
    return Promise.resolve(window.LightweightCharts);
  }

  if (lightweightChartsPromise) {
    return lightweightChartsPromise;
  }

  lightweightChartsPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector(
      `script[data-lightweight-charts="true"][src="${LIGHTWEIGHT_CHARTS_SRC}"]`
    );

    if (existing) {
      existing.addEventListener("load", () => {
        if (window.LightweightCharts?.createChart) {
          resolve(window.LightweightCharts);
        } else {
          reject(new Error("lightweight-charts loaded without global"));
        }
      });
      existing.addEventListener("error", () => {
        reject(new Error("Failed to load lightweight-charts"));
      });
      return;
    }

    const script = document.createElement("script");
    script.src = LIGHTWEIGHT_CHARTS_SRC;
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.dataset.lightweightCharts = "true";
    script.onload = () => {
      if (window.LightweightCharts?.createChart) {
        resolve(window.LightweightCharts);
      } else {
        reject(new Error("lightweight-charts loaded without global"));
      }
    };
    script.onerror = () => {
      reject(new Error("Failed to load lightweight-charts"));
    };
    document.head.appendChild(script);
  }).catch((error) => {
    lightweightChartsPromise = null;
    throw error;
  });

  return lightweightChartsPromise;
};
